import Tooltip from 'kpc/components/tooltip';
import Copy from '../copy';
import { _$ } from 'kpc/components/utils';
export default function (obj, _Vdt, blocks, $callee) {
  _Vdt || (_Vdt = Vdt);
  obj || (obj = {});
  blocks || (blocks = {});
  var h = _Vdt.miss.h,
      hc = _Vdt.miss.hc,
      hu = _Vdt.miss.hu,
      widgets = this && this.widgets || {},
      _blocks = {},
      __blocks = {},
      __u = _Vdt.utils,
      extend = __u.extend,
      _e = __u.error,
      _className = __u.className,
      __o = __u.Options,
      _getModel = __o.getModel,
      _setModel = __o.setModel,
      _setCheckboxModel = __u.setCheckboxModel,
      _detectCheckboxChecked = __u.detectCheckboxChecked,
      _setSelectModel = __u.setSelectModel,
      self = this.data,
      $this = this,
      scope = obj,
      Animate = self && self.Animate,
      parent = ($callee || {})._super;

  var _self$get = self.get(),
      id = _self$get.id,
      children = _self$get.children,
      className = _self$get.className;

  return h('div', null, h(Tooltip, {
    'canHover': function () {
      try {
        return [true][0];
      } catch (e) {
        _e(e);
      }
    }.call(this),
    'showArrow': function () {
      try {
        return [false][0];
      } catch (e) {
        _e(e);
      }
    }.call(this),
    'position': function () {
      try {
        return [{
          my: 'left top',
          at: 'left bottom'
        }][0];
      } catch (e) {
        _e(e);
      }
    }.call(this),
    'className': 'k-copy-id',
    'children': h('span', null, 'ID', 'k-id'),
    '_context': $this,
    '_blocks': function (blocks) {
      var _blocks = {},
          __blocks = extend({}, blocks);

      return (_blocks["content"] = function (parent) {
        return [h('div', null, function () {
          try {
            return [id][0];
          } catch (e) {
            _e(e);
          }
        }.call(this)), h(Copy, {
          'text': function () {
            try {
              return [id][0];
            } catch (e) {
              _e(e);
            }
          }.call(this),
          'ev-success': function () {
            try {
              return [self._success][0];
            } catch (e) {
              _e(e);
            }
          }.call(this),
          'children': ['\n                ', function () {
            try {
              return [_$('复制')][0];
            } catch (e) {
              _e(e);
            }
          }.call(this), '\n            '],
          '_context': $this
        })];
      }) && (__blocks["content"] = function (parent) {
        var self = this;
        return blocks["content"] ? blocks["content"].call(this, function () {
          return _blocks["content"].call(self, parent);
        }) : _blocks["content"].call(this, parent);
      }), __blocks;
    }.call(this, {})
  }), _className(function () {
    try {
      var _ref;

      return [(_ref = {
        'k-component-copy-id': true
      }, _ref[className] = className, _ref)][0];
    } catch (e) {
      _e(e);
    }
  }.call(this)));
}